const ErrorStep = () => <div>Error. Please reset the Widget</div>;

export default ErrorStep;
